import {useContext} from "react"
import {StWorkflowContext} from "../contexts/StWorkflowContext"

export function useStWorkflowContext() {
    const context = useContext(StWorkflowContext)
    if (!context) {
        throw new Error("useStWorkflowContext must be used within a StWorkflowContext")
    }
    return context
}